import _slicedToArray from "/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = Object.defineProperty,
    t = Object.defineProperties,
    n = Object.getOwnPropertyDescriptors,
    o = Object.getOwnPropertySymbols,
    i = Object.prototype.hasOwnProperty,
    r = Object.prototype.propertyIsEnumerable,
    a = function a(t, n, o) {
  return n in t ? e(t, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : t[n] = o;
},
    s = function s(e, t) {
  for (var n in t || (t = {})) {
    i.call(t, n) && a(e, n, t[n]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        r.call(t, n) && a(e, n, t[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

import c, { useState as u, useEffect as d, useRef as l } from "react";
var f = "Please consider reporting this error at https://github.com/laymonage/giscus/issues/new.";

function m(e) {
  return "[giscus] An error occurred. Error message: \"".concat(e, "\".");
}

function g(e) {
  var t = document.querySelector("meta[property='og:".concat(e, "'],meta[name='").concat(e, "']"));
  return t ? t.content : "";
}

function h() {
  var e = document.getElementById("giscus-css") || document.createElement("style");
  e.id = "giscus-css", e.textContent = "\n    .giscus, .giscus-frame {\n      width: 100%;\n    }\n    .giscus-frame {\n      border: none;\n      color-scheme: auto;\n    }\n  ", document.head.prepend(e);
}

var p,
    w = {},
    b = {
  exports: {}
};
p = b, function (e) {
  if ("undefined" != typeof window) {
    var t,
        n = 0,
        o = !1,
        i = !1,
        r = "message".length,
        a = "[iFrameSizer]",
        s = a.length,
        c = null,
        u = window.requestAnimationFrame,
        d = {
      max: 1,
      scroll: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    },
        l = {},
        f = null,
        m = {
      autoResize: !0,
      bodyBackground: null,
      bodyMargin: null,
      bodyMarginV1: 8,
      bodyPadding: null,
      checkOrigin: !0,
      inPageLinks: !1,
      enablePublicMethods: !0,
      heightCalculationMethod: "bodyOffset",
      id: "iFrameResizer",
      interval: 32,
      log: !1,
      maxHeight: 1 / 0,
      maxWidth: 1 / 0,
      minHeight: 0,
      minWidth: 0,
      mouseEvents: !0,
      resizeFrom: "parent",
      scrolling: !1,
      sizeHeight: !0,
      sizeWidth: !1,
      warningTimeout: 5e3,
      tolerance: 0,
      widthCalculationMethod: "scroll",
      onClose: function onClose() {
        return !0;
      },
      onClosed: function onClosed() {},
      onInit: function onInit() {},
      onMessage: function onMessage() {
        I("onMessage function not defined");
      },
      onMouseEnter: function onMouseEnter() {},
      onMouseLeave: function onMouseLeave() {},
      onResized: function onResized() {},
      onScroll: function onScroll() {
        return !0;
      }
    },
        g = {};
    window.jQuery && ((t = window.jQuery).fn ? t.fn.iFrameResize || (t.fn.iFrameResize = function (e) {
      return this.filter("iframe").each(function (t, n) {
        W(n, e);
      }).end();
    }) : T("", "Unable to bind to jQuery, it is not fully loaded.")), p.exports = D(), window.iFrameResize = window.iFrameResize || D();
  }

  function h() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  }

  function w(e, t, n) {
    e.addEventListener(t, n, !1);
  }

  function b(e, t, n) {
    e.removeEventListener(t, n, !1);
  }

  function y(e) {
    return a + "[" + function (e) {
      var t = "Host page: " + e;
      return window.top !== window.self && (t = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ": " + e : "Nested host page: " + e), t;
    }(e) + "]";
  }

  function v(e) {
    return l[e] ? l[e].log : o;
  }

  function E(e, t) {
    O("log", e, t, v(e));
  }

  function T(e, t) {
    O("info", e, t, v(e));
  }

  function I(e, t) {
    O("warn", e, t, !0);
  }

  function O(e, t, n, o) {
    !0 === o && "object" == typeof window.console && console[e](y(t), n);
  }

  function M(e) {
    function t() {
      i("Height"), i("Width"), A(function () {
        C(q), z(D), y("onResized", q);
      }, q, "init");
    }

    function n(e) {
      return "border-box" !== e.boxSizing ? 0 : (e.paddingTop ? parseInt(e.paddingTop, 10) : 0) + (e.paddingBottom ? parseInt(e.paddingBottom, 10) : 0);
    }

    function o(e) {
      return "border-box" !== e.boxSizing ? 0 : (e.borderTopWidth ? parseInt(e.borderTopWidth, 10) : 0) + (e.borderBottomWidth ? parseInt(e.borderBottomWidth, 10) : 0);
    }

    function i(e) {
      var t = Number(l[D]["max" + e]),
          n = Number(l[D]["min" + e]),
          o = e.toLowerCase(),
          i = Number(q[o]);
      E(D, "Checking " + o + " is in range " + n + "-" + t), i < n && (i = n, E(D, "Set " + o + " to min value")), i > t && (i = t, E(D, "Set " + o + " to max value")), q[o] = "" + i;
    }

    function u(e) {
      return B.substr(B.indexOf(":") + r + e);
    }

    function d(e, t) {
      var n, o, i;
      n = function n() {
        var n, o;
        P("Send Page Info", "pageInfo:" + (n = document.body.getBoundingClientRect(), o = q.iframe.getBoundingClientRect(), JSON.stringify({
          iframeHeight: o.height,
          iframeWidth: o.width,
          clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
          clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
          offsetTop: parseInt(o.top - n.top, 10),
          offsetLeft: parseInt(o.left - n.left, 10),
          scrollTop: window.pageYOffset,
          scrollLeft: window.pageXOffset,
          documentHeight: document.documentElement.clientHeight,
          documentWidth: document.documentElement.clientWidth,
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth
        })), e, t);
      }, o = 32, g[i = t] || (g[i] = setTimeout(function () {
        g[i] = null, n();
      }, o));
    }

    function f(e) {
      var t = e.getBoundingClientRect();
      return N(D), {
        x: Math.floor(Number(t.left) + Number(c.x)),
        y: Math.floor(Number(t.top) + Number(c.y))
      };
    }

    function m(e) {
      var t = e ? f(q.iframe) : {
        x: 0,
        y: 0
      },
          n = {
        x: Number(q.width) + t.x,
        y: Number(q.height) + t.y
      };
      E(D, "Reposition requested from iFrame (offset x:" + t.x + " y:" + t.y + ")"), window.top !== window.self ? window.parentIFrame ? window.parentIFrame["scrollTo" + (e ? "Offset" : "")](n.x, n.y) : I(D, "Unable to scroll to requested position, window.parentIFrame not found") : (c = n, h(), E(D, "--"));
    }

    function h() {
      !1 !== y("onScroll", c) ? z(D) : R();
    }

    function p(e) {
      var t = {};

      if (0 === Number(q.width) && 0 === Number(q.height)) {
        var n = u(9).split(":");
        t = {
          x: n[1],
          y: n[0]
        };
      } else t = {
        x: q.width,
        y: q.height
      };

      y(e, {
        iframe: q.iframe,
        screenX: Number(t.x),
        screenY: Number(t.y),
        type: q.type
      });
    }

    function y(e, t) {
      return S(D, e, t);
    }

    var v,
        O,
        M,
        x,
        W,
        j,
        H,
        B = e.data,
        q = {},
        D = null;
    "[iFrameResizerChild]Ready" === B ? function () {
      for (var e in l) {
        P("iFrame requested init", L(e), l[e].iframe, e);
      }
    }() : a === ("" + B).substr(0, s) && B.substr(s).split(":")[0] in l ? (x = B.substr(s).split(":"), W = x[1] ? parseInt(x[1], 10) : 0, j = l[x[0]] && l[x[0]].iframe, H = getComputedStyle(j), q = {
      iframe: j,
      id: x[0],
      height: W + n(H) + o(H),
      width: x[2],
      type: x[3]
    }, D = q.id, l[D] && (l[D].loaded = !0), (M = q.type in {
      true: 1,
      false: 1,
      undefined: 1
    }) && E(D, "Ignoring init message from meta parent page"), !M && (O = !0, l[v = D] || (O = !1, I(q.type + " No settings for " + v + ". Message was: " + B)), O) && (E(D, "Received: " + B), function () {
      var e = !0;
      return null === q.iframe && (I(D, "IFrame (" + q.id + ") not found"), e = !1), e;
    }() && function () {
      var t,
          n = e.origin,
          o = l[D] && l[D].checkOrigin;
      if (o && "" + n != "null" && !(o.constructor === Array ? function () {
        var e = 0,
            t = !1;

        for (E(D, "Checking connection is from allowed list of origins: " + o); e < o.length; e++) {
          if (o[e] === n) {
            t = !0;
            break;
          }
        }

        return t;
      }() : (t = l[D] && l[D].remoteHost, E(D, "Checking connection is from: " + t), n === t))) throw new Error("Unexpected message received from: " + n + " for " + q.iframe.id + ". Message was: " + e.data + ". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.");
      return !0;
    }() && function () {
      switch (l[D] && l[D].firstRun && l[D] && (l[D].firstRun = !1), q.type) {
        case "close":
          k(q.iframe);
          break;

        case "message":
          r = u(6), E(D, "onMessage passed: {iframe: " + q.iframe.id + ", message: " + r + "}"), y("onMessage", {
            iframe: q.iframe,
            message: JSON.parse(r)
          }), E(D, "--");
          break;

        case "mouseenter":
          p("onMouseEnter");
          break;

        case "mouseleave":
          p("onMouseLeave");
          break;

        case "autoResize":
          l[D].autoResize = JSON.parse(u(9));
          break;

        case "scrollTo":
          m(!1);
          break;

        case "scrollToOffset":
          m(!0);
          break;

        case "pageInfo":
          d(l[D] && l[D].iframe, D), function () {
            function e(e, o) {
              function i() {
                l[n] ? d(l[n].iframe, n) : t();
              }

              ["scroll", "resize"].forEach(function (t) {
                E(n, e + t + " listener for sendPageInfo"), o(window, t, i);
              });
            }

            function t() {
              e("Remove ", b);
            }

            var n = D;
            e("Add ", w), l[n] && (l[n].stopPageInfo = t);
          }();
          break;

        case "pageInfoStop":
          l[D] && l[D].stopPageInfo && (l[D].stopPageInfo(), delete l[D].stopPageInfo);
          break;

        case "inPageLink":
          n = u(9).split("#")[1] || "", o = decodeURIComponent(n), (i = document.getElementById(o) || document.getElementsByName(o)[0]) ? (e = f(i), E(D, "Moving to in page link (#" + n + ") at x: " + e.x + " y: " + e.y), c = {
            x: e.x,
            y: e.y
          }, h(), E(D, "--")) : window.top !== window.self ? window.parentIFrame ? window.parentIFrame.moveToAnchor(n) : E(D, "In page link #" + n + " not found and window.parentIFrame not found") : E(D, "In page link #" + n + " not found");
          break;

        case "reset":
          F(q);
          break;

        case "init":
          t(), y("onInit", q.iframe);
          break;

        default:
          0 === Number(q.width) && 0 === Number(q.height) ? I("Unsupported message received (" + q.type + "), this is likely due to the iframe containing a later version of iframe-resizer than the parent page") : t();
      }

      var e, n, o, i, r;
    }())) : T(D, "Ignored: " + B);
  }

  function S(e, t, n) {
    var o = null,
        i = null;

    if (l[e]) {
      if ("function" != typeof (o = l[e][t])) throw new TypeError(t + " on iFrame[" + e + "] is not a function");
      i = o(n);
    }

    return i;
  }

  function x(e) {
    var t = e.id;
    delete l[t];
  }

  function k(e) {
    var t = e.id;

    if (!1 !== S(t, "onClose", t)) {
      E(t, "Removing iFrame: " + t);

      try {
        e.parentNode && e.parentNode.removeChild(e);
      } catch (n) {
        I(n);
      }

      S(t, "onClosed", t), E(t, "--"), x(e);
    } else E(t, "Close iframe cancelled by onClose event");
  }

  function N(t) {
    null === c && E(t, "Get page position: " + (c = {
      x: window.pageXOffset !== e ? window.pageXOffset : document.documentElement.scrollLeft,
      y: window.pageYOffset !== e ? window.pageYOffset : document.documentElement.scrollTop
    }).x + "," + c.y);
  }

  function z(e) {
    null !== c && (window.scrollTo(c.x, c.y), E(e, "Set page position: " + c.x + "," + c.y), R());
  }

  function R() {
    c = null;
  }

  function F(e) {
    E(e.id, "Size reset requested by " + ("init" === e.type ? "host page" : "iFrame")), N(e.id), A(function () {
      C(e), P("reset", "reset", e.iframe, e.id);
    }, e, "reset");
  }

  function C(e) {
    function t(t) {
      i || "0" !== e[t] || (i = !0, E(o, "Hidden iFrame detected, creating visibility listener"), function () {
        function e() {
          function e(e) {
            function t(t) {
              return "0px" === (l[e] && l[e].iframe.style[t]);
            }

            function n(e) {
              return null !== e.offsetParent;
            }

            l[e] && n(l[e].iframe) && (t("height") || t("width")) && P("Visibility change", "resize", l[e].iframe, e);
          }

          Object.keys(l).forEach(function (t) {
            e(t);
          });
        }

        function t(t) {
          E("window", "Mutation observed: " + t[0].target + " " + t[0].type), j(e, 16);
        }

        function n() {
          var e = document.querySelector("body"),
              n = {
            attributes: !0,
            attributeOldValue: !1,
            characterData: !0,
            characterDataOldValue: !1,
            childList: !0,
            subtree: !0
          };
          new o(t).observe(e, n);
        }

        var o = h();
        o && n();
      }());
    }

    function n(n) {
      !function (t) {
        e.id ? (e.iframe.style[t] = e[t] + "px", E(e.id, "IFrame (" + o + ") " + t + " set to " + e[t] + "px")) : E("undefined", "messageData id not set");
      }(n), t(n);
    }

    var o = e.iframe.id;
    l[o] && (l[o].sizeHeight && n("height"), l[o].sizeWidth && n("width"));
  }

  function A(e, t, n) {
    n !== t.type && u && !window.jasmine ? (E(t.id, "Requesting animation frame"), u(e)) : e();
  }

  function P(e, t, n, o, i) {
    var r,
        s = !1;
    o = o || n.id, l[o] && (n && "contentWindow" in n && null !== n.contentWindow ? (r = l[o] && l[o].targetOrigin, E(o, "[" + e + "] Sending msg to iframe[" + o + "] (" + t + ") targetOrigin: " + r), n.contentWindow.postMessage(a + t, r)) : I(o, "[" + e + "] IFrame(" + o + ") not found"), i && l[o] && l[o].warningTimeout && (l[o].msgTimeout = setTimeout(function () {
      !l[o] || l[o].loaded || s || (s = !0, I(o, "IFrame has not responded within " + l[o].warningTimeout / 1e3 + " seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning."));
    }, l[o].warningTimeout)));
  }

  function L(e) {
    return e + ":" + l[e].bodyMarginV1 + ":" + l[e].sizeWidth + ":" + l[e].log + ":" + l[e].interval + ":" + l[e].enablePublicMethods + ":" + l[e].autoResize + ":" + l[e].bodyMargin + ":" + l[e].heightCalculationMethod + ":" + l[e].bodyBackground + ":" + l[e].bodyPadding + ":" + l[e].tolerance + ":" + l[e].inPageLinks + ":" + l[e].resizeFrom + ":" + l[e].widthCalculationMethod + ":" + l[e].mouseEvents;
  }

  function W(t, i) {
    function r(e) {
      var t = e.split("Callback");

      if (2 === t.length) {
        var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
        this[n] = this[e], delete this[e], I(b, "Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.");
      }
    }

    var a,
        s,
        c,
        u,
        f,
        g,
        p,
        b = ("" === (a = t.id) && (t.id = (s = i && i.id || m.id + n++, null !== document.getElementById(s) && (s += n++), a = s), o = (i || {}).log, E(a, "Added missing iframe ID: " + a + " (" + t.src + ")")), a);
    b in l && "iFrameResizer" in t ? I(b, "Ignored iFrame, already setup.") : (g = (g = i) || {}, l[b] = {
      firstRun: !0,
      iframe: t,
      remoteHost: t.src && t.src.split("/").slice(0, 3).join("/")
    }, function (e) {
      if ("object" != typeof e) throw new TypeError("Options is not an object");
    }(g), Object.keys(g).forEach(r, g), function (e) {
      for (var t in m) {
        Object.prototype.hasOwnProperty.call(m, t) && (l[b][t] = Object.prototype.hasOwnProperty.call(e, t) ? e[t] : m[t]);
      }
    }(g), l[b] && (l[b].targetOrigin = !0 === l[b].checkOrigin ? "" === (p = l[b].remoteHost) || null !== p.match(/^(about:blank|javascript:|file:\/\/)/) ? "*" : p : "*"), function () {
      switch (E(b, "IFrame scrolling " + (l[b] && l[b].scrolling ? "enabled" : "disabled") + " for " + b), t.style.overflow = !1 === (l[b] && l[b].scrolling) ? "hidden" : "auto", l[b] && l[b].scrolling) {
        case "omit":
          break;

        case !0:
          t.scrolling = "yes";
          break;

        case !1:
          t.scrolling = "no";
          break;

        default:
          t.scrolling = l[b] ? l[b].scrolling : "no";
      }
    }(), function () {
      function e(e) {
        var n = l[b][e];
        n !== 1 / 0 && 0 !== n && (t.style[e] = "number" == typeof n ? n + "px" : n, E(b, "Set " + e + " = " + t.style[e]));
      }

      function n(e) {
        if (l[b]["min" + e] > l[b]["max" + e]) throw new Error("Value for min" + e + " can not be greater than max" + e);
      }

      n("Height"), n("Width"), e("maxHeight"), e("minHeight"), e("maxWidth"), e("minWidth");
    }(), "number" != typeof (l[b] && l[b].bodyMargin) && "0" !== (l[b] && l[b].bodyMargin) || (l[b].bodyMarginV1 = l[b].bodyMargin, l[b].bodyMargin = l[b].bodyMargin + "px"), c = L(b), (f = h()) && (u = f, t.parentNode && new u(function (e) {
      e.forEach(function (e) {
        Array.prototype.slice.call(e.removedNodes).forEach(function (e) {
          e === t && k(t);
        });
      });
    }).observe(t.parentNode, {
      childList: !0
    })), w(t, "load", function () {
      var n, o;
      P("iFrame.onload", c, t, e, !0), n = l[b] && l[b].firstRun, o = l[b] && l[b].heightCalculationMethod in d, !n && o && F({
        iframe: t,
        height: 0,
        width: 0,
        type: "init"
      });
    }), P("init", c, t, e, !0), l[b] && (l[b].iframe.iFrameResizer = {
      close: k.bind(null, l[b].iframe),
      removeListeners: x.bind(null, l[b].iframe),
      resize: P.bind(null, "Window resize", "resize", l[b].iframe),
      moveToAnchor: function moveToAnchor(e) {
        P("Move to anchor", "moveToAnchor:" + e, l[b].iframe, b);
      },
      sendMessage: function sendMessage(e) {
        P("Send Message", "message:" + (e = JSON.stringify(e)), l[b].iframe, b);
      }
    }));
  }

  function j(e, t) {
    null === f && (f = setTimeout(function () {
      f = null, e();
    }, t));
  }

  function H() {
    "hidden" !== document.visibilityState && (E("document", "Trigger event: Visiblity change"), j(function () {
      B("Tab Visable", "resize");
    }, 16));
  }

  function B(e, t) {
    Object.keys(l).forEach(function (n) {
      (function (e) {
        return l[e] && "parent" === l[e].resizeFrom && l[e].autoResize && !l[e].firstRun;
      })(n) && P(e, t, l[n].iframe, n);
    });
  }

  function q() {
    w(window, "message", M), w(window, "resize", function () {
      var e;
      E("window", "Trigger event: " + (e = "resize")), j(function () {
        B("Window " + e, "resize");
      }, 16);
    }), w(document, "visibilitychange", H), w(document, "-webkit-visibilitychange", H);
  }

  function D() {
    function t(e, t) {
      t && (function () {
        if (!t.tagName) throw new TypeError("Object is not a valid DOM element");
        if ("IFRAME" !== t.tagName.toUpperCase()) throw new TypeError("Expected <IFRAME> tag, found <" + t.tagName + ">");
      }(), W(t, e), n.push(t));
    }

    var n;
    return function () {
      var e,
          t = ["moz", "webkit", "o", "ms"];

      for (e = 0; e < t.length && !u; e += 1) {
        u = window[t[e] + "RequestAnimationFrame"];
      }

      u ? u = u.bind(window) : E("setup", "RequestAnimationFrame not supported");
    }(), q(), function (o, i) {
      switch (n = [], function (e) {
        e && e.enablePublicMethods && I("enablePublicMethods option has been removed, public methods are now always available in the iFrame");
      }(o), typeof i) {
        case "undefined":
        case "string":
          Array.prototype.forEach.call(document.querySelectorAll(i || "iframe"), t.bind(e, o));
          break;

        case "object":
          t(o, i);
          break;

        default:
          throw new TypeError("Unexpected data type (" + typeof i + ")");
      }

      return n;
    };
  }
}();
var y = {
  exports: {}
};
!function (e) {
  !function (t) {
    if ("undefined" != typeof window) {
      var n = !0,
          o = "",
          i = 0,
          r = "",
          a = null,
          s = "",
          c = !1,
          u = {
        resize: 1,
        click: 1
      },
          d = 128,
          l = !0,
          f = 1,
          m = "bodyOffset",
          g = m,
          h = !0,
          p = "",
          w = {},
          b = 32,
          y = null,
          v = !1,
          E = !1,
          T = "[iFrameSizer]",
          I = T.length,
          O = "",
          M = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
      },
          S = "child",
          x = window.parent,
          k = "*",
          N = 0,
          z = !1,
          R = null,
          F = 16,
          C = 1,
          A = "scroll",
          P = A,
          L = window,
          W = function W() {
        re("onMessage function not defined");
      },
          j = function j() {},
          H = function H() {},
          B = {
        height: function height() {
          return re("Custom height calculation function not defined"), document.documentElement.offsetHeight;
        },
        width: function width() {
          return re("Custom width calculation function not defined"), document.body.scrollWidth;
        }
      },
          q = {},
          D = !1;

      try {
        var U = Object.create({}, {
          passive: {
            get: function get() {
              D = !0;
            }
          }
        });
        window.addEventListener("test", ee, U), window.removeEventListener("test", ee, U);
      } catch (ke) {}

      var $,
          V,
          J,
          X,
          Y,
          Q,
          K,
          G = {
        bodyOffset: function bodyOffset() {
          return document.body.offsetHeight + pe("marginTop") + pe("marginBottom");
        },
        offset: function offset() {
          return G.bodyOffset();
        },
        bodyScroll: function bodyScroll() {
          return document.body.scrollHeight;
        },
        custom: function custom() {
          return B.height();
        },
        documentElementOffset: function documentElementOffset() {
          return document.documentElement.offsetHeight;
        },
        documentElementScroll: function documentElementScroll() {
          return document.documentElement.scrollHeight;
        },
        max: function max() {
          return Math.max.apply(null, be(G));
        },
        min: function min() {
          return Math.min.apply(null, be(G));
        },
        grow: function grow() {
          return G.max();
        },
        lowestElement: function lowestElement() {
          return Math.max(G.bodyOffset() || G.documentElementOffset(), we("bottom", ve()));
        },
        taggedElement: function taggedElement() {
          return ye("bottom", "data-iframe-height");
        }
      },
          Z = {
        bodyScroll: function bodyScroll() {
          return document.body.scrollWidth;
        },
        bodyOffset: function bodyOffset() {
          return document.body.offsetWidth;
        },
        custom: function custom() {
          return B.width();
        },
        documentElementScroll: function documentElementScroll() {
          return document.documentElement.scrollWidth;
        },
        documentElementOffset: function documentElementOffset() {
          return document.documentElement.offsetWidth;
        },
        scroll: function scroll() {
          return Math.max(Z.bodyScroll(), Z.documentElementScroll());
        },
        max: function max() {
          return Math.max.apply(null, be(Z));
        },
        min: function min() {
          return Math.min.apply(null, be(Z));
        },
        rightMostElement: function rightMostElement() {
          return we("right", ve());
        },
        taggedElement: function taggedElement() {
          return ye("right", "data-iframe-width");
        }
      },
          _ = ($ = Ee, Y = null, Q = 0, K = function K() {
        Q = Date.now(), Y = null, X = $.apply(V, J), Y || (V = J = null);
      }, function () {
        var e = Date.now();
        Q || (Q = e);
        var t = F - (e - Q);
        return V = this, J = arguments, t <= 0 || t > F ? (Y && (clearTimeout(Y), Y = null), Q = e, X = $.apply(V, J), Y || (V = J = null)) : Y || (Y = setTimeout(K, t)), X;
      });

      te(window, "message", function (t) {
        var n = {
          init: function init() {
            p = t.data, x = t.source, ae(), l = !1, setTimeout(function () {
              h = !1;
            }, d);
          },
          reset: function reset() {
            h ? ie("Page reset ignored by init") : (ie("Page size reset by host page"), Oe("resetPage"));
          },
          resize: function resize() {
            Te("resizeParent", "Parent window requested size check");
          },
          moveToAnchor: function moveToAnchor() {
            w.findTarget(i());
          },
          inPageLink: function inPageLink() {
            this.moveToAnchor();
          },
          pageInfo: function pageInfo() {
            var e = i();
            ie("PageInfoFromParent called from parent: " + e), H(JSON.parse(e)), ie(" --");
          },
          message: function message() {
            var e = i();
            ie("onMessage called from parent: " + e), W(JSON.parse(e)), ie(" --");
          }
        };

        function o() {
          return t.data.split("]")[1].split(":")[0];
        }

        function i() {
          return t.data.substr(t.data.indexOf(":") + 1);
        }

        function r() {
          return t.data.split(":")[2] in {
            true: 1,
            false: 1
          };
        }

        function a() {
          var i = o();
          i in n ? n[i]() : !e.exports && "iFrameResize" in window || "jQuery" in window && "iFrameResize" in window.jQuery.prototype || r() || re("Unexpected message (" + t.data + ")");
        }

        T === ("" + t.data).substr(0, I) && (!1 === l ? a() : r() ? n.init() : ie('Ignored message of type "' + o() + '". Received before initialization.'));
      }), te(window, "readystatechange", xe), xe();
    }

    function ee() {}

    function te(e, t, n, o) {
      e.addEventListener(t, n, !!D && (o || {}));
    }

    function ne(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    function oe(e) {
      return T + "[" + O + "] " + e;
    }

    function ie(e) {
      v && "object" == typeof window.console && console.log(oe(e));
    }

    function re(e) {
      "object" == typeof window.console && console.warn(oe(e));
    }

    function ae() {
      var e;
      !function () {
        function e(e) {
          return "true" === e;
        }

        var a = p.substr(I).split(":");
        O = a[0], i = t !== a[1] ? Number(a[1]) : i, c = t !== a[2] ? e(a[2]) : c, v = t !== a[3] ? e(a[3]) : v, b = t !== a[4] ? Number(a[4]) : b, n = t !== a[6] ? e(a[6]) : n, r = a[7], g = t !== a[8] ? a[8] : g, o = a[9], s = a[10], N = t !== a[11] ? Number(a[11]) : N, w.enable = t !== a[12] && e(a[12]), S = t !== a[13] ? a[13] : S, P = t !== a[14] ? a[14] : P, E = t !== a[15] ? Boolean(a[15]) : E;
      }(), ie("Initialising iFrame (" + window.location.href + ")"), function () {
        function e() {
          var e = window.iFrameResizer;
          ie("Reading data from page: " + JSON.stringify(e)), Object.keys(e).forEach(se, e), W = "onMessage" in e ? e.onMessage : W, j = "onReady" in e ? e.onReady : j, k = "targetOrigin" in e ? e.targetOrigin : k, g = "heightCalculationMethod" in e ? e.heightCalculationMethod : g, P = "widthCalculationMethod" in e ? e.widthCalculationMethod : P;
        }

        function t(e, t) {
          return "function" == typeof e && (ie("Setup custom " + t + "CalcMethod"), B[t] = e, e = "custom"), e;
        }

        "iFrameResizer" in window && Object === window.iFrameResizer.constructor && (e(), g = t(g, "height"), P = t(P, "width"));
        ie("TargetOrigin for parent set to: " + k);
      }(), function () {
        t === r && (r = i + "px");
        ce("margin", function (e, t) {
          -1 !== t.indexOf("-") && (re("Negative CSS value ignored for " + e), t = "");
          return t;
        }("margin", r));
      }(), ce("background", o), ce("padding", s), (e = document.createElement("div")).style.clear = "both", e.style.display = "block", e.style.height = "0", document.body.appendChild(e), fe(), me(), document.documentElement.style.height = "", document.body.style.height = "", ie('HTML & body height set to "auto"'), ie("Enable public methods"), L.parentIFrame = {
        autoResize: function autoResize(e) {
          return !0 === e && !1 === n ? (n = !0, ge()) : !1 === e && !0 === n && (n = !1, de("remove"), null !== a && a.disconnect(), clearInterval(y)), Se(0, 0, "autoResize", JSON.stringify(n)), n;
        },
        close: function close() {
          Se(0, 0, "close");
        },
        getId: function getId() {
          return O;
        },
        getPageInfo: function getPageInfo(e) {
          "function" == typeof e ? (H = e, Se(0, 0, "pageInfo")) : (H = function H() {}, Se(0, 0, "pageInfoStop"));
        },
        moveToAnchor: function moveToAnchor(e) {
          w.findTarget(e);
        },
        reset: function reset() {
          Me("parentIFrame.reset");
        },
        scrollTo: function scrollTo(e, t) {
          Se(t, e, "scrollTo");
        },
        scrollToOffset: function scrollToOffset(e, t) {
          Se(t, e, "scrollToOffset");
        },
        sendMessage: function sendMessage(e, t) {
          Se(0, 0, "message", JSON.stringify(e), t);
        },
        setHeightCalculationMethod: function setHeightCalculationMethod(e) {
          g = e, fe();
        },
        setWidthCalculationMethod: function setWidthCalculationMethod(e) {
          P = e, me();
        },
        setTargetOrigin: function setTargetOrigin(e) {
          ie("Set targetOrigin: " + e), k = e;
        },
        size: function size(e, t) {
          Te("size", "parentIFrame.size(" + (e || "") + (t ? "," + t : "") + ")", e, t);
        }
      }, function () {
        if (!0 !== E) return;

        function e(e) {
          Se(0, 0, e.type, e.screenY + ":" + e.screenX);
        }

        function t(t, n) {
          ie("Add event listener: " + n), te(window.document, t, e);
        }

        t("mouseenter", "Mouse Enter"), t("mouseleave", "Mouse Leave");
      }(), ge(), w = function () {
        function e() {
          return {
            x: window.pageXOffset !== t ? window.pageXOffset : document.documentElement.scrollLeft,
            y: window.pageYOffset !== t ? window.pageYOffset : document.documentElement.scrollTop
          };
        }

        function n(t) {
          var n = t.getBoundingClientRect(),
              o = e();
          return {
            x: parseInt(n.left, 10) + parseInt(o.x, 10),
            y: parseInt(n.top, 10) + parseInt(o.y, 10)
          };
        }

        function o(e) {
          function o(e) {
            var t = n(e);
            ie("Moving to in page link (#" + i + ") at x: " + t.x + " y: " + t.y), Se(t.y, t.x, "scrollToOffset");
          }

          var i = e.split("#")[1] || e,
              r = decodeURIComponent(i),
              a = document.getElementById(r) || document.getElementsByName(r)[0];
          t !== a ? o(a) : (ie("In page link (#" + i + ") not found in iFrame, so sending to parent"), Se(0, 0, "inPageLink", "#" + i));
        }

        function i() {
          var e = window.location.hash,
              t = window.location.href;
          "" !== e && "#" !== e && o(t);
        }

        function r() {
          function e(e) {
            function t(e) {
              e.preventDefault(), o(this.getAttribute("href"));
            }

            "#" !== e.getAttribute("href") && te(e, "click", t);
          }

          Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), e);
        }

        function a() {
          te(window, "hashchange", i);
        }

        function s() {
          setTimeout(i, d);
        }

        function c() {
          Array.prototype.forEach && document.querySelectorAll ? (ie("Setting up location.hash handlers"), r(), a(), s()) : re("In page linking not fully supported in this browser! (See README.md for IE8 workaround)");
        }

        w.enable ? c() : ie("In page linking not enabled");
        return {
          findTarget: o
        };
      }(), Te("init", "Init message from host page"), j();
    }

    function se(e) {
      var t = e.split("Callback");

      if (2 === t.length) {
        var n = "on" + t[0].charAt(0).toUpperCase() + t[0].slice(1);
        this[n] = this[e], delete this[e], re("Deprecated: '" + e + "' has been renamed '" + n + "'. The old method will be removed in the next major version.");
      }
    }

    function ce(e, n) {
      t !== n && "" !== n && "null" !== n && (document.body.style[e] = n, ie("Body " + e + ' set to "' + n + '"'));
    }

    function ue(e) {
      var t = {
        add: function add(t) {
          function n() {
            Te(e.eventName, e.eventType);
          }

          q[t] = n, te(window, t, n, {
            passive: !0
          });
        },
        remove: function remove(e) {
          var t,
              n,
              o,
              i = q[e];
          delete q[e], t = window, n = e, o = i, t.removeEventListener(n, o, !1);
        }
      };
      e.eventNames && Array.prototype.map ? (e.eventName = e.eventNames[0], e.eventNames.map(t[e.method])) : t[e.method](e.eventName), ie(ne(e.method) + " event listener: " + e.eventType);
    }

    function de(e) {
      ue({
        method: e,
        eventType: "Animation Start",
        eventNames: ["animationstart", "webkitAnimationStart"]
      }), ue({
        method: e,
        eventType: "Animation Iteration",
        eventNames: ["animationiteration", "webkitAnimationIteration"]
      }), ue({
        method: e,
        eventType: "Animation End",
        eventNames: ["animationend", "webkitAnimationEnd"]
      }), ue({
        method: e,
        eventType: "Input",
        eventName: "input"
      }), ue({
        method: e,
        eventType: "Mouse Up",
        eventName: "mouseup"
      }), ue({
        method: e,
        eventType: "Mouse Down",
        eventName: "mousedown"
      }), ue({
        method: e,
        eventType: "Orientation Change",
        eventName: "orientationchange"
      }), ue({
        method: e,
        eventType: "Print",
        eventName: ["afterprint", "beforeprint"]
      }), ue({
        method: e,
        eventType: "Ready State Change",
        eventName: "readystatechange"
      }), ue({
        method: e,
        eventType: "Touch Start",
        eventName: "touchstart"
      }), ue({
        method: e,
        eventType: "Touch End",
        eventName: "touchend"
      }), ue({
        method: e,
        eventType: "Touch Cancel",
        eventName: "touchcancel"
      }), ue({
        method: e,
        eventType: "Transition Start",
        eventNames: ["transitionstart", "webkitTransitionStart", "MSTransitionStart", "oTransitionStart", "otransitionstart"]
      }), ue({
        method: e,
        eventType: "Transition Iteration",
        eventNames: ["transitioniteration", "webkitTransitionIteration", "MSTransitionIteration", "oTransitionIteration", "otransitioniteration"]
      }), ue({
        method: e,
        eventType: "Transition End",
        eventNames: ["transitionend", "webkitTransitionEnd", "MSTransitionEnd", "oTransitionEnd", "otransitionend"]
      }), "child" === S && ue({
        method: e,
        eventType: "IFrame Resized",
        eventName: "resize"
      });
    }

    function le(e, t, n, o) {
      return t !== e && (e in n || (re(e + " is not a valid option for " + o + "CalculationMethod."), e = t), ie(o + ' calculation method set to "' + e + '"')), e;
    }

    function fe() {
      g = le(g, m, G, "height");
    }

    function me() {
      P = le(P, A, Z, "width");
    }

    function ge() {
      var e;
      !0 === n ? (de("add"), e = 0 > b, window.MutationObserver || window.WebKitMutationObserver ? e ? he() : a = function () {
        function e(e) {
          function t(e) {
            !1 === e.complete && (ie("Attach listeners to " + e.src), e.addEventListener("load", i, !1), e.addEventListener("error", r, !1), c.push(e));
          }

          "attributes" === e.type && "src" === e.attributeName ? t(e.target) : "childList" === e.type && Array.prototype.forEach.call(e.target.querySelectorAll("img"), t);
        }

        function t(e) {
          c.splice(c.indexOf(e), 1);
        }

        function n(e) {
          ie("Remove listeners from " + e.src), e.removeEventListener("load", i, !1), e.removeEventListener("error", r, !1), t(e);
        }

        function o(e, t, o) {
          n(e.target), Te(t, o + ": " + e.target.src);
        }

        function i(e) {
          o(e, "imageLoad", "Image loaded");
        }

        function r(e) {
          o(e, "imageLoadFailed", "Image load failed");
        }

        function a(t) {
          Te("mutationObserver", "mutationObserver: " + t[0].target + " " + t[0].type), t.forEach(e);
        }

        function s() {
          var e = document.querySelector("body"),
              t = {
            attributes: !0,
            attributeOldValue: !1,
            characterData: !0,
            characterDataOldValue: !1,
            childList: !0,
            subtree: !0
          };
          return d = new u(a), ie("Create body MutationObserver"), d.observe(e, t), d;
        }

        var c = [],
            u = window.MutationObserver || window.WebKitMutationObserver,
            d = s();
        return {
          disconnect: function disconnect() {
            "disconnect" in d && (ie("Disconnect body MutationObserver"), d.disconnect(), c.forEach(n));
          }
        };
      }() : (ie("MutationObserver not supported in this browser!"), he())) : ie("Auto Resize disabled");
    }

    function he() {
      0 !== b && (ie("setInterval: " + b + "ms"), y = setInterval(function () {
        Te("interval", "setInterval: " + b);
      }, Math.abs(b)));
    }

    function pe(e, t) {
      var n = 0;
      return t = t || document.body, n = null !== (n = document.defaultView.getComputedStyle(t, null)) ? n[e] : 0, parseInt(n, 10);
    }

    function we(e, t) {
      for (var n = t.length, o = 0, i = 0, r = ne(e), a = Date.now(), s = 0; s < n; s++) {
        (o = t[s].getBoundingClientRect()[e] + pe("margin" + r, t[s])) > i && (i = o);
      }

      return a = Date.now() - a, ie("Parsed " + n + " HTML elements"), ie("Element position calculated in " + a + "ms"), function (e) {
        e > F / 2 && ie("Event throttle increased to " + (F = 2 * e) + "ms");
      }(a), i;
    }

    function be(e) {
      return [e.bodyOffset(), e.bodyScroll(), e.documentElementOffset(), e.documentElementScroll()];
    }

    function ye(e, t) {
      var n = document.querySelectorAll("[" + t + "]");
      return 0 === n.length && (re("No tagged elements (" + t + ") found on page"), document.querySelectorAll("body *")), we(e, n);
    }

    function ve() {
      return document.querySelectorAll("body *");
    }

    function Ee(e, n, o, i) {
      var r, a;
      !function () {
        function e(e, t) {
          return !(Math.abs(e - t) <= N);
        }

        return r = t !== o ? o : G[g](), a = t !== i ? i : Z[P](), e(f, r) || c && e(C, a);
      }() && "init" !== e ? !(e in {
        init: 1,
        interval: 1,
        size: 1
      }) && (g in M || c && P in M) ? Me(n) : e in {
        interval: 1
      } || ie("No change in size detected") : (Ie(), Se(f = r, C = a, e));
    }

    function Te(e, t, n, o) {
      z && e in u ? ie("Trigger event cancelled: " + e) : (e in {
        reset: 1,
        resetPage: 1,
        init: 1
      } || ie("Trigger event: " + t), "init" === e ? Ee(e, t, n, o) : _(e, t, n, o));
    }

    function Ie() {
      z || (z = !0, ie("Trigger event lock on")), clearTimeout(R), R = setTimeout(function () {
        z = !1, ie("Trigger event lock off"), ie("--");
      }, d);
    }

    function Oe(e) {
      f = G[g](), C = Z[P](), Se(f, C, e);
    }

    function Me(e) {
      var t = g;
      g = m, ie("Reset trigger event: " + e), Ie(), Oe("reset"), g = t;
    }

    function Se(e, n, o, i, r) {
      var a;
      t === r ? r = k : ie("Message targetOrigin: " + r), ie("Sending message to host page (" + (a = O + ":" + e + ":" + n + ":" + o + (t !== i ? ":" + i : "")) + ")"), x.postMessage(T + a, r);
    }

    function xe() {
      "loading" !== document.readyState && window.parent.postMessage("[iFrameResizerChild]Ready", "*");
    }
  }();
}(y);
var v = b.exports;
w.iframeResize = v, w.iframeResizer = v, w.iframeResizerContentWindow = y.exports;
var E = w;

function T(e) {
  var _u = u(""),
      _u2 = _slicedToArray(_u, 2),
      o = _u2[0],
      i = _u2[1],
      r = function (_ref) {
    var e = _ref.repo,
        t = _ref.repoId,
        _ref$category = _ref.category,
        n = _ref$category === void 0 ? "" : _ref$category,
        _ref$categoryId = _ref.categoryId,
        o = _ref$categoryId === void 0 ? "" : _ref$categoryId,
        i = _ref.mapping,
        _ref$term = _ref.term,
        r = _ref$term === void 0 ? "" : _ref$term,
        _ref$theme = _ref.theme,
        a = _ref$theme === void 0 ? "light" : _ref$theme,
        _ref$reactionsEnabled = _ref.reactionsEnabled,
        s = _ref$reactionsEnabled === void 0 ? "1" : _ref$reactionsEnabled,
        _ref$emitMetadata = _ref.emitMetadata,
        c = _ref$emitMetadata === void 0 ? "0" : _ref$emitMetadata,
        _ref$inputPosition = _ref.inputPosition,
        u = _ref$inputPosition === void 0 ? "bottom" : _ref$inputPosition,
        _ref$lang = _ref.lang,
        d = _ref$lang === void 0 ? "en" : _ref$lang,
        l = _ref.session,
        f = _ref.origin;
    var m = new URL(location.href);
    m.searchParams.delete("giscus");
    var h = m.toString(),
        p = {
      origin: f = f || h,
      session: l,
      theme: a,
      reactionsEnabled: s,
      emitMetadata: c,
      inputPosition: u,
      repo: e,
      repoId: t,
      category: n,
      categoryId: o,
      description: g("description")
    };

    switch (i) {
      case "url":
        p.term = h;
        break;

      case "title":
        p.term = document.title;
        break;

      case "og:title":
        p.term = g("title");
        break;

      case "specific":
        p.term = r;
        break;

      case "number":
        p.number = r;
        break;

      case "pathname":
      default:
        p.term = location.pathname.length < 2 ? "index" : location.pathname.substring(1).replace(/\.\w+$/, "");
    }

    return "https://giscus.app/".concat(d, "/widget?").concat(new URLSearchParams(p));
  }((a = s({}, e), t(a, n({
    session: o
  }))));

  var a;
  var p = l(null);
  return d(function () {
    var e = location.href,
        t = new URL(e),
        n = localStorage.getItem("giscus-session"),
        o = t.searchParams.get("giscus") || "";
    if (o) return localStorage.setItem("giscus-session", JSON.stringify(o)), i(o), t.searchParams.delete("giscus"), void history.replaceState(void 0, document.title, t.toString());
    if (n) try {
      i(JSON.parse(n || "") || "");
    } catch (r) {
      i(""), localStorage.removeItem("giscus-session"), console.warn("".concat(m(null == r ? void 0 : r.message), " Session has been cleared."));
    }
  }, []), d(h, []), d(function () {
    var e = (t = function t() {
      return i("");
    }, function (e) {
      var n;
      if ("https://giscus.app" !== e.origin) return;
      var o = e.data;
      if ("object" != typeof o || !(null == (n = null == o ? void 0 : o.giscus) ? void 0 : n.error)) return;
      var i = o.giscus.error;

      if (i.includes("Bad credentials") || i.includes("Invalid state value")) {
        if (null !== localStorage.getItem("giscus-session")) return localStorage.removeItem("giscus-session"), t(), void console.warn("".concat(m(i), " Session has been cleared."));
        console.error("".concat(m(i), " No session is stored initially. ").concat(f));
      }

      i.includes("Discussion not found") ? console.warn("[giscus] ".concat(i, ". A new discussion will be created if a comment/reaction is submitted.")) : console.error("".concat(m(i), " ").concat(f));
    });
    var t;
    return window.addEventListener("message", e), function () {
      return window.removeEventListener("message", e);
    };
  }, []), d(function () {
    p.current && p.current.addEventListener("load", function () {
      return E.iframeResizer({
        checkOrigin: ["https://giscus.app"]
      }, p.current);
    });
  }, [r]), c.createElement("div", {
    className: "giscus"
  }, c.createElement("iframe", {
    className: "giscus-frame",
    title: "Comments",
    src: r,
    ref: p
  }));
}

function I(e) {
  var _u3 = u(!1),
      _u4 = _slicedToArray(_u3, 2),
      t = _u4[0],
      n = _u4[1];

  return d(function () {
    return n(!0);
  }, []), t ? c.createElement(T, s({}, e)) : null;
}

export { I as Giscus };